// extracted by mini-css-extract-plugin
module.exports = {"faqProviderSection":"FAQProviderContainer_faqProviderSection__1QNY3","mainTitle":"FAQProviderContainer_mainTitle__2ZwTI","container":"FAQProviderContainer_container__kyX0t"};